import React from "react";
import FemaleClipPath from "./FemaleClipPath";
import BackFemaleBodyParts from "./BackFemaleBodyParts";
import FrontFemaleBodyParts from "./FrontFemaleBodyParts";
const BothFemalePicker = (props) => {
    return (React.createElement("svg", { version: "1.1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 1390 1370", xmlSpace: "preserve", "data-testid": "bothFemaleBodyPartPicker" },
        React.createElement("defs", null,
            React.createElement(FemaleClipPath, { x: "0", clipId: "female-both-clip" })),
        React.createElement(FrontFemaleBodyParts, Object.assign({ clipPathId: "female-both-clip" }, props)),
        React.createElement(BackFemaleBodyParts, Object.assign({ clipPathId: "female-both-clip", className: "female-back-both-sides" }, props))));
};
export { BothFemalePicker };
export default BothFemalePicker;
//# sourceMappingURL=BothFemalePicker.js.map